/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CalibrationDataState } from './CalibrationDataState';
import {
    instanceOfCalibrationDataState,
    CalibrationDataStateFromJSON,
    CalibrationDataStateFromJSONTyped,
    CalibrationDataStateToJSON,
} from './CalibrationDataState';

/**
 * @type PtwQaEquipmentWithRegistrationDtoCalibrationState
 * 
 * @export
 */
export type PtwQaEquipmentWithRegistrationDtoCalibrationState = CalibrationDataState;


export function PtwQaEquipmentWithRegistrationDtoCalibrationStateFromJSON(json: any): PtwQaEquipmentWithRegistrationDtoCalibrationState {
    return PtwQaEquipmentWithRegistrationDtoCalibrationStateFromJSONTyped(json, false);
}

export function PtwQaEquipmentWithRegistrationDtoCalibrationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PtwQaEquipmentWithRegistrationDtoCalibrationState {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...CalibrationDataStateFromJSONTyped(json, true) };
    return  CalibrationDataStateFromJSONTyped(json, true);
}

export function PtwQaEquipmentWithRegistrationDtoCalibrationStateToJSON(value?: PtwQaEquipmentWithRegistrationDtoCalibrationState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCalibrationDataState(value)) {
        return CalibrationDataStateToJSON(value as CalibrationDataState);
    }

    return {};
}

/**
 * Check if a given object implements the PtwQaEquipmentWithRegistrationDtoCalibrationState interface.
 */
export function instanceOfPtwQaEquipmentWithRegistrationDtoCalibrationState(value: any): value is PtwQaEquipmentWithRegistrationDtoCalibrationState {
    if (instanceOfCalibrationDataState(value)) return true;
    return false;
}

